import { TranslateService } from '@ngx-translate/core';

export class ServiceNonExistentError extends Error {
	constructor() {
		super('_ws-framework.guard.service-non-existent');
	}
}
